import React, { useState } from 'react';
import classNames from 'classnames';

import { FormattedMessage, useIntl } from '../../../util/reactIntl';
import {
  buildGeneralReferralUrl,
  copyReferralLink,
  shareReferralLink,
} from '../../../util/referral';

import {
  InlineTextButton,
  Modal,
  PrimaryButton,
  ReferralShareModal,
  SecondaryButton,
} from '../../../components';
import approvedPrimaryButtonCss from '../../../styles/approvedPrimaryButton.module.css';

import css from './InviteUserControl.module.css';

const InviteUserControl = props => {
  const { id, currentUser, buttonClassName, onManageDisableScrolling = () => {} } = props;
  const intl = useIntl();
  const [isOpen, setOpen] = useState(false);
  const [areShareOptionsOpen, setShareOptionsOpen] = useState(false);
  const [status, setStatus] = useState(null);
  const userId = currentUser?.id?.uuid;

  if (!userId) {
    return null;
  }

  const invitationUrl =
    typeof window !== 'undefined' ? buildGeneralReferralUrl(window.location.origin, userId) : '';
  const close = () => {
    setOpen(false);
    setStatus(null);
  };
  const copy = () => {
    copyReferralLink(invitationUrl)
      .then(() => setStatus('copied'))
      .catch(() => setStatus('error'));
  };
  const share = () => {
    shareReferralLink({
      title: 'ResuelvePR',
      text: intl.formatMessage({ id: 'InviteUserControl.shareText' }),
      url: invitationUrl,
    })
      .then(result => {
        if (result === 'alternatives') {
          setOpen(false);
          setShareOptionsOpen(true);
        } else if (result === 'shared') {
          setStatus('shared');
        }
      })
      .catch(() => setStatus('error'));
  };

  return (
    <>
      <InlineTextButton rootClassName={buttonClassName} type="button" onClick={() => setOpen(true)}>
        <FormattedMessage id="InviteUserControl.open" />
      </InlineTextButton>
      <Modal
        id={id}
        containerClassName={css.modal}
        contentClassName={css.content}
        isOpen={isOpen}
        onClose={close}
        onManageDisableScrolling={onManageDisableScrolling}
        usePortal
        closeButtonMessage={intl.formatMessage({ id: 'InviteUserControl.close' })}
      >
        <h2 className={css.title}>
          <FormattedMessage id="InviteUserControl.title" />
        </h2>
        <p className={css.text}>
          <FormattedMessage id="InviteUserControl.description" />
        </p>
        <div className={css.url}>{invitationUrl}</div>
        {status ? (
          <p className={classNames(css.status, { [css.error]: status === 'error' })} role="status">
            <FormattedMessage id={`InviteUserControl.${status}`} />
          </p>
        ) : null}
        <div className={css.actions}>
          <SecondaryButton type="button" onClick={copy}>
            <FormattedMessage id="InviteUserControl.copy" />
          </SecondaryButton>
          <PrimaryButton
            type="button"
            className={approvedPrimaryButtonCss.approvedPrimaryButton}
            onClick={share}
          >
            <FormattedMessage id="InviteUserControl.share" />
          </PrimaryButton>
        </div>
      </Modal>
      <ReferralShareModal
        id={`${id}ShareOptions`}
        isOpen={areShareOptionsOpen}
        onClose={() => setShareOptionsOpen(false)}
        onManageDisableScrolling={onManageDisableScrolling}
        title="ResuelvePR"
        text={intl.formatMessage({ id: 'InviteUserControl.shareText' })}
        url={invitationUrl}
      />
    </>
  );
};

export default InviteUserControl;
